import {
  getMetadata,
  hasMetadata,
} from 'eurogard-reflect-metadata';
import {
  EUROGARD_TABLE_ACTION_METHOD_METADATA,
  TableActionMethodOptions,
} from './decorators';
import {
  RowActionCheckFunction,
  TableRowActionMethod,
  TableRowActionTypeMethod,
  TableRowActionTypeSwitchMethod,
} from './types';

export function IsTableRowActionTypeSwitchMethod<Data extends Record<string, any>>(
  method: TableRowActionMethod<Data>,
): method is TableRowActionTypeSwitchMethod<Data> {
  return getMetadata<TableActionMethodOptions>(
    EUROGARD_TABLE_ACTION_METHOD_METADATA,
    method.constructor,
  )?.type === undefined;
}

export function IsTableRowActionTypeMethod<Data extends Record<string, any>>(
  type: string,
) {
  return (
    method: TableRowActionMethod<Data>,
  ): method is TableRowActionTypeMethod<Data> => {
    return (
      getMetadata<TableActionMethodOptions>(
        EUROGARD_TABLE_ACTION_METHOD_METADATA,
        method.constructor,
      )?.type === type
    );
  };
}

export function HasTableRowActionCheckFunction(method: TableRowActionMethod<any>): boolean {
  return getMetadata<TableActionMethodOptions>(
    EUROGARD_TABLE_ACTION_METHOD_METADATA,
    method.constructor,
  )?.checkFunction !== undefined;
}

export function GetTableRowActionCheckFunction<Data extends Record<string, unknown> = Record<string, unknown>>(method: TableRowActionMethod<Data>): RowActionCheckFunction<Data> {
  const checkFunction = getMetadata<TableActionMethodOptions<Data>>(
    EUROGARD_TABLE_ACTION_METHOD_METADATA,
    method.constructor,
  )?.checkFunction;
  if (!checkFunction) {
    throw new Error(`Extracted check function from '${ method.constructor.name }' is empty`);
  }
  return checkFunction;
}

export function HasTableRowActionMetadata(method: TableRowActionMethod): boolean {
  return hasMetadata(
    EUROGARD_TABLE_ACTION_METHOD_METADATA,
    method.constructor,
  );
}

export function GetTableRowActionMetadata(method: TableRowActionMethod): TableActionMethodOptions {
  const metadata = getMetadata<TableActionMethodOptions>(
    EUROGARD_TABLE_ACTION_METHOD_METADATA,
    method.constructor,
  );
  if (!metadata) {
    throw new Error(`Extracted metadata from '${ method.constructor.name }' is empty`);
  }
  return metadata;
}
